import { render, staticRenderFns } from "./ComponentSettingsDeleteFormItem.vue?vue&type=template&id=343267ea&scoped=true"
import script from "./ComponentSettingsDeleteFormItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentSettingsDeleteFormItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ComponentSettingsDeleteFormItem.vue?vue&type=style&index=0&id=343267ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343267ea",
  null
  
)

export default component.exports